<template>
     <div class="servicecontract-search">
          <PageTitle 
                icon="fa fa-clone" 
                main="Record" sub="Service Contract" 
                />
            <b-form 
                v-show="mode === 'save' || mode === 'remove' || mode === 'read'" >
             <input 
                id="servicecontract-id" 
                type="hidden" 
                v-model="servicecontract.id" />
             <b-row>
                <b-col md="2" sm="12">
                    <b-form-group
                    label="Contract Date:"
                    label-for="servicecontract-date_service_contract"
                    >
                    <b-form-input
                    id="servicecontract-date_service_contract"
                    type="date"
                    v-model="servicecontract.date_service_contract"
                    :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                    size="sm"
                    />
                    </b-form-group>
                </b-col>
                <b-col md="8" sm="12">
                    <b-form-group 
                        label="Service:" 
                        label-for="servicecontract-default_service_type_id_service_contract">
                        <b-select 
                            id="servicecontract-default_service_type_id_service_contract"
                            size="sm"
                            :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                            :options="defaultservicetypes" 
                            v-model="servicecontract.default_service_type_id_service_contract" 
                            />
                    </b-form-group>
                </b-col> 
             </b-row>
             <b-row>
                  <b-col md="5" sm="12">
                        <b-form-group 
                            label="Contractor:" 
                            label-for="servicecontract-entity_id_service_contract">
                            <b-select 
                                id="servicecontract-entity_id_service_contract"
                                size="sm"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                :options="entitys" 
                                v-model="servicecontract.entity_id_service_contract" 
                                />
                    </b-form-group>
                </b-col> 
                 <b-col md="3" sm="12">
                        <b-form-group 
                            label="Billing Type:" 
                            label-for="servicecontract-billing_type_id_service_contract">
                            <b-select 
                                id="servicecontract-billing_type_id_service_contract"
                                size="sm"
                                :disabled="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                :options="billingtypes" 
                                v-model="servicecontract.billing_type_id_service_contract" 
                                />
                    </b-form-group>
                </b-col> 
                 <b-col md="2" sm="12">
                        <b-form-group
                            label="Fixed Value:"
                            label-for="servicecontract-value_service_contract"
                        >
                            <b-form-input
                                id="servicecontract-value_service_contract"
                                type="number"
                                v-model="servicecontract.value_service_contract"
                                size="sm"
                                step="0.02"
                                 :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
                     <b-col md="2" sm="12">
                        <b-form-group
                            label="Hourly Rate:"
                            label-for="servicecontract-hourly_rate_contract"
                        >
                            <b-form-input
                                id="servicecontract-hourly_rate_contract"
                                type="number"
                                v-model="servicecontract.hourly_rate_contract"
                                size="sm"
                                step="0.02"
                                 :readonly="mode === 'remove' || mode === 'read' || mode === 'insert'"
                                pattern="([0-9]{1,3}\.)?[0-9]{1,3},[0-9]{2}$"
                            />
                        </b-form-group>
                    </b-col>
             </b-row>
           
        <br>
         </b-form>

            <hr v-show="mode === 'save'">
              <b-row>
                <b-col xs="12">
                   <b-button  
                        size="sm" 
                        variant="light" 
                        title="Add"
                        class="mt-2  mb-2 fa fa-plus" 
                        v-show="mode !== 'save' && mode !== 'remove'"
                        @click="alterModo">
                    </b-button>
                    <b-button 
                        size="sm" 
                        variant="light"
                         title="Save"
                        class="mt-2 mb-2 ml-2 fa fa-save" 
                        v-if="mode === 'save'"
                        @click="save">
                        </b-button>
                    <b-button 
                        size="sm" 
                        variant="light" 
                         title="Delete"
                        class="mt-2 mb-2 ml-2 fa fa-trash" 
                        v-if="mode === 'remove'"
                        @click="remove">
                    </b-button>
                    <b-button 
                        size="sm" 
                        btn-sm 
                        variant="light" 
                         title="Back"
                        class="mt-2 mb-2 ml-2 fa fa-mail-reply"  
                        v-if="mode === 'remove' || mode === 'save' || mode === 'read' "
                        @click="reset">
                    </b-button>
                    <b-button 
                         size="sm" 
                         class="mt-2 mb-2 ml-2 fa" 
                          title="Search"
                         :class="icon" 
                         @click="[loadOwnerContracts(),toggleBusy(),showTable = !showTable]" 
                         variant="light" >
                    </b-button>
                </b-col>
            </b-row>
            <br>
            <b-row v-show="mode !== 'save' && mode !== 'remove'">
                   <div class="col-sm-4">
                    <div class="form-group">
                        <input 
                            type="text" 
                            size="sm" 
                            icon="search" 
                            v-model="search" 
                           
                              v-show="mode !== 'save' && mode !== 'remove'"
                            placeholder="Search by contractor name" 
                            class="form-control">
                    </div>
                </div>  
          <transition  name="slide" type="animation" appear>       
         <b-table 
                 :busy="isBusy"  
                class="table-responsive" 
                :per-page="perPage" 
                :current-page="currentPage" 
                hover 
                 head-variant="dark" 
                v-show="showTable"
                :items="filteredList" 
                :fields="fields">
                <template v-slot:table-busy>
                    <div class="text-center text-info my-2">
                        <b-spinner class="align-middle"></b-spinner>
                        <strong>Loading...</strong>
                    </div>
                </template>
               <template v-slot:cell(actions)="data">
                     <b-button  
                        v-if="!data.item.confirmed_date_service_contract"
                        title = "Approval" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxApproval(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-check-square-o"></i>
                    </b-button>    
                          <b-button  
                        v-if="!data.item.canceled_date_service_contract"
                        title = "Cancel" 
                        size="sm" 
                        variant="light" 
                        @click="showMsgBoxCanceled(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-ban"></i>
                    </b-button>        
                    <b-button  
                        title = "View" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'read')" 
                        class="mr-2 mt-2">
                        <i class="fa fa-drivers-license-o"></i>
                    </b-button>
                    <b-button  
                        title = "Edit" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item)" 
                        class="mr-2 mt-2">
                        <i class="fa fa-pencil"></i>
                    </b-button>
                     <b-button  
                        title = "Delete" 
                        size="sm" 
                        variant="light" 
                        @click="loadOwner(data.item, 'remove')" class="mr-2 mt-2">
                        <i class="fa fa-trash"></i>
                    </b-button>
                </template>    
         </b-table> 
          </transition>
          <transition  name="slide" type="animation" appear>
            <b-pagination
                v-show="showTable"
                v-model="currentPage"
                :total-rows="rows"
                :per-page="perPage"
                size="sm"
                aria-controls="my-table"
            ></b-pagination>
          </transition>
        </b-row>
            
     </div>
</template>

<script>
import { baseApiUrl, showError } from '@/global'
import axios from 'axios'
import PageTitle from '../template/PageTitle'

var moment = require('moment-timezone')

export default {
    name: 'ServiceContractSearch',
    components: {PageTitle },
    data: function() {
        return {
                mode: 'insert',
                search: '',
                servicecontract: {},
                servicecontractitem: {},
                immobile: {},
                servicecontractitems:[],
                owners:[],
                defaultservicetypes:[],
                servicecontracts: [],
                billingtypes: [],
                servicecontractcontracts:[],
                entitys: [],
                perPage: 5,
                currentPage: 1,
                 isBusy: false,
                 showTable: false,
                headerBgVariant: 'dark',
                headerTextVariant: 'light',
                bodyBgVariant: 'light',
                bodyTextVariant: 'dark',
                footerBgVariant: 'warning',
                footerTextVariant: 'dark',
                fields: [
                {
                    key: 'date_service_contract',label: 'Contract Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
                    { key: 'name_entity', label: 'Contractor', sortable: false ,variant: 'light'},
                    { key: 'name_default_service_type', label: 'Service', sortable: false ,variant: 'light'},
                    { key: 'name_billing_type', label: 'Billing', sortable: false ,variant: 'light'},
                    { key: 'value_service_contract', label: 'Fixed Value', sortable: false ,variant: 'light'},
                    { key: 'hourly_rate_contract', label: 'Hourly Rate', sortable: false ,variant: 'light'},
                    { key: 'confirmed_date_service_contract',label: 'Confirmed Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
                    { key: 'closing_date_service_contract',label: 'Closing Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
                     { key: 'canceled_date_service_contract',label: 'Canceled Date',sortable: true,
                            formatter: value =>
                            value ? moment.utc(value).format('MM-DD-YYYY') : '',variant: 'light'
                    },
               
                { key: 'actions', label: 'Action',variant: 'light' },
                //{ key: 'accesses', label: 'Acessos',variant: 'secondary' }
                ],
               
            }
        },
        computed: {
            filteredList() {
                return this.servicecontracts.filter(servicecontract => {
                    return servicecontract.name_entity.toLowerCase().includes(this.search.toLowerCase())
                    })
            },
            compan(){
                return this.$store.state.compan
            },
            icon() {
            return this.showTable ? "fa-retweet" : "fa-search";
            },
            rows() {
                return this.servicecontracts.length
            },
            user(){
                    return this.$store.state.user
            },
        },
        methods:{
             async showMsgBoxApproval(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to approval the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'success',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.approval(item)
                    }
                })
            },
             async showMsgBoxCanceled(item) {
                this.boxCancel = ''
                this.$bvModal
                    .msgBoxConfirm('Do you want to canceled the record?', {
                    title: 'Please confirm',
                    size: 'sm',
                    buttonSize: 'sm',
                    okVariant: 'danger',
                    okTitle: 'Yes',
                    cancelTitle: 'No',
                    footerClass: 'p-2',
                    hideHeaderClose: false,
                    centered: true
                })
                .then(async value => {
                    this.boxCancel = value
                    if (this.boxCancel === true) {
                        await this.approval(item)
                    }
                })
            },
            formatDateTime(date) {
                return moment(date)
                    .utcOffset(-3)
                    .format('YYYY-MM-DD LT')
            },
            formatDate(value) {
                return moment(value)
                    .format('YYYY-MM-DD')
            },
            toggleBusy() {
                this.isBusy = !this.isBusy
            },
            loadOwnerContracts(){
                const url = `${baseApiUrl}/servicecontractsbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.servicecontracts = res.data
                      this.isBusy = false
                })
            },
            alterModo() {
                    this.mode = 'save'
                    this.servicecontract = {}
                    this.servicecontractitem = {}
                    this.$refs.searchFocus.focus();
            },
             reset() {
                this.mode = 'insert'
                this.loadOwnerContracts()              
                this.servicecontract = {}
            },
            async approval(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/servicecontractsapproval/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerContracts()

                        })
                        .catch(showError)

           },
             async canceled(item) {

                 const method = 'put'

                  await axios[method](
                        `${baseApiUrl}/servicecontractscanceled/${item.id}`,
                        this.item
                    )
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.loadOwnerContracts()

                        })
                        .catch(showError)

           },
            async save() {

                const method = this.servicecontract.id ? 'put' : 'post'
                const id = this.servicecontract.id ? `/${this.servicecontract.id}` : ''

                if(this.servicecontract.id){
                    this.servicecontract.update_date_service_contract = this.formatDateTime(Date())
                    this.servicecontract.update_user_service_contract = this.user.id
                }else{
                    this.servicecontract.user_id_service_contract = this.user.id
                    this.servicecontract.company_id_service_contract = this.compan.id
                }

                await axios[method](`${baseApiUrl}/servicecontracts${id}`, this.servicecontract)
                    .then(() => {
                        this.$toasted.global.defaultSuccess()
                        this.reset()
                    })
                    .catch(showError)
            },
            remove() {
                    const id = this.servicecontract.id
                    axios.delete(`${baseApiUrl}/servicecontracts/${id}`)
                        .then(() => {
                            this.$toasted.global.defaultSuccess()
                            this.reset()
                        })
                        .catch(showError)
            },
            loadOwner(servicecontract, mode = 'save') {
                this.mode = mode
                 if(servicecontract.date_service_contract) servicecontract.date_service_contract = this.formatDate(servicecontract.date_service_contract)
                this.servicecontract = { ...servicecontract }
                this.$refs.searchFocus.focus();
     
            },
            loadDefaultServiceRequests() {
                const url = `${baseApiUrl}/defaultservicetypesbycompany/${this.compan.id}`
                axios.get(url).then(res => {
                    this.defaultservicetypes = res.data.map(type => {
                        return { value: type.id, text: type.name_default_service_type }
                    })
                })
            },
            loadBillingTypes(){
                const url = `${baseApiUrl}/billingtypes`
                axios(url).then(res =>{
                     this.billingtypes = res.data.map(billingtype =>{
                        return {value: billingtype.id, text: billingtype.name_billing_type }
                     })
                })
            },
            loadEntitys(){
                const url = `${baseApiUrl}/entitysbycompany/${this.compan.id}`
                axios(url).then(res =>{
                     this.entitys = res.data.map(type => {
                        return { value: type.id, text: type.name_entity }
                    })
                
                })
            },

        },
        mounted(){
            this.loadOwnerContracts()
            this.loadBillingTypes()
            this.loadEntitys()
            this.loadDefaultServiceRequests()
            this.showTable = true
        }
}
</script>

<style>


    .servicecontract-search{
        font-size: 0.75rem;
        color: white;
   
    }

    .servicecontract-search button{
        font-size: 0.75rem;
    }

     .servicecontract-search select{
        font-size: 0.75rem;
    }

    .servicecontract-search input{
        font-size: 0.75rem;
    }

    .servicecontract-search-card label{
        font-size: 0.75rem;
        color: black;
   
    }



    #modalBank {
        font-size: 0.75rem;
    }

    #modalBank button{
        font-size: 0.75rem;
    }

     #modalBank input{
        font-size: 0.75rem;
    }

      #modalBank label{
        font-size: 0.75rem;
        color: black;
    }

     #modalImmobile {
        font-size: 0.75rem;
    }

    #modalImmobile button{
        font-size: 0.75rem;
    }

     #modalImmobile input{
        font-size: 0.75rem;
    }

      #modalImmobile select{
        font-size: 0.75rem;
    }

      #modalImmobile label{
        font-size: 0.75rem;
        color: black;
    }


    
@keyframes slide-in {
  from {
    transform: translateY(40px);
  }
  to {
    transform: translateY(0);
  }
}

@keyframes slide-out {
  from {
    transform: translateY(0);
  }
  to {
    transform: translateY(40px);
  }
}

.slide-enter-active {
  animation: slide-in 1s ease;
  transition: opacity 1s;
}

.slide-leave-active {
  animation: slide-out 1s ease;
  transition: opacity 1s;
}

.slide-enter,
.slide-leave-to {
  opacity: 0;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 1s;
}

</style>
